import { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { auth } from "@app/config/firebase";
import { ROUTES } from "@app/constants";

const UNAUTHORIZED_EVENT = "unauthorized-access";

export const UnauthorizedModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleUnauthorized = () => {
      setIsOpen(true);
    };

    window.addEventListener(UNAUTHORIZED_EVENT, handleUnauthorized);

    return () => {
      window.removeEventListener(UNAUTHORIZED_EVENT, handleUnauthorized);
    };
  }, []);

  const handleSignOut = async () => {
    await auth.signOut();
    setIsOpen(false);
  };

  const handleGoBack = () => {
    const historyLength = window.history.length;
    const referrer = document.referrer;
    const currentUrl = window.location.href;
    const currentPath = window.location.pathname;

    // Check if there's no back entry (history length is 1 or less)
    if (historyLength <= 1) {
      window.location.pathname = ROUTES.HOME;
      setIsOpen(false);
      return;
    }

    // Check if we're already on the home route
    if (currentPath === ROUTES.HOME || currentPath === ROUTES.BRIEF) {
      window.location.pathname = ROUTES.HOME;
      setIsOpen(false);
      return;
    }

    // Check if referrer exists and is different from current URL
    // If referrer is empty or same as current, navigate to home
    if (
      !referrer ||
      referrer === currentUrl ||
      referrer === window.location.origin + currentPath
    ) {
      window.location.pathname = ROUTES.HOME;
      setIsOpen(false);
      return;
    }

    // Use window.history to go back
    window.history.back();
    setIsOpen(false);
  };

  return (
    <Modal
      title="Unauthorized Access"
      open={isOpen}
      closable={false}
      maskClosable={false}
      footer={[
        <Button key="signout" type="primary" onClick={handleGoBack}>
          Go Back
        </Button>,
      ]}
      onCancel={undefined}
    >
      <p>
        You are not authorized to access this page. Please sign out and log in
        again.
      </p>
    </Modal>
  );
};

export const triggerUnauthorizedModal = () => {
  window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
};
